import { useEffect } from 'react';

interface SharedIntervalInterface {
  (
    intervalName: string,
    callbackFunction: (timestamp: number) => void,
    intervalTime?: number
  ): void;
}

const listeners = new Map<string, ((timestamp: number) => void)[]>();
const intervals = new Map<string, NodeJS.Timeout>();

const useSharedInterval: SharedIntervalInterface = (
  intervalName,
  callbackFunction,
  intervalTime
) => {
  useEffect(() => {
    const intervalListeners = listeners.get(intervalName) || [];
    const newListeners = [callbackFunction, ...intervalListeners];
    listeners.set(intervalName, newListeners);
    startInterval(intervalName, intervalTime);
    return () => {
      const intervalListeners = listeners.get(intervalName) || [];
      const filteredOutListeners = intervalListeners.filter(
        listener => listener !== callbackFunction
      );
      listeners.set(intervalName, filteredOutListeners);
      if (!filteredOutListeners.length) {
        const interval = intervals.get(intervalName);
        interval && clearInterval(interval);
        intervals.delete(intervalName);
      }
    };
  }, [intervalName, callbackFunction, intervalTime]);
};

function startInterval(intervalName: string, intervalTime?: number) {
  if (!intervals.has(intervalName)) {
    intervals.set(
      intervalName,
      setInterval(() => notifyIntervalWatchers(intervalName), intervalTime || 0)
    );
  }
}

function notifyIntervalWatchers(intervalName: string) {
  const intervalListeners = listeners.get(intervalName) || [];
  const timestamp = Date.now();
  intervalListeners.forEach(listener => listener(timestamp));
}

export default useSharedInterval;
